<template>
    <b-container class="py-5">
        <h4>범용 자동완성 컴포넌트 사용 예제</h4>
        <auto-complete-select
            v-model="selectedItem"
            :options="projectOptions"
            :loading="isLoading"
            startExpanded
            option-text-key="name"
            option-value-key="id"
            placeholder="기간을 선택해주세요"
            @click="onItemClick"
        />
        <div class="mt-3">
            <strong>선택된 값 (v-model):</strong>
            <pre>{{ selectedItem }}</pre>
        </div>
    </b-container>
</template>

<script>
import AutoCompleteSelect from '@core_components/common/AutoCompleteSelect.vue';
import {optionsData} from './data';
import dayjs from 'dayjs';
export default {
    components: {
        AutoCompleteSelect
    },
    data() {
        return {
            selectedItem: null, // v-model과 연결될 데이터
            isLoading: false,
            // props로 전달할 옵션 데이터
            projectOptions: [
            ],
        };
    },
    created(){
        console.log('build cache invalidate');
        const mapOptions = {};
        optionsData.forEach(item => {
            if(mapOptions[item.period] == null) {
                mapOptions[item.period] = [];
            }
            if (item.period && item.period.includes('_')) {
                let _active_project_period = item.period.split('_');
                _active_project_period[0] = dayjs(_active_project_period[0]).format('YYYY');
                _active_project_period[1] = _active_project_period[1].replace(/h/gi, '');
                item.period_dis = {
                    ko: `${_active_project_period[0]}년 ${_active_project_period[1] === '1' ? '상반기' : '하반기'}`,
                    en: `H${_active_project_period[1]} ${_active_project_period[0]}`,
                    ca: `${_active_project_period[0]}年${_active_project_period[1] === '1' ? '上半年' : '下半年'}`
                };
            }
            mapOptions[item.period].push({
                value: item,
                name: `${item.project_code} (${item.period_dis.ko})`,
                id: item.index
            });
        });
        Object.entries(mapOptions).forEach(([key, value]) => {
            this.projectOptions.push({
                group: key,
                items: value
            });
        });
    },
    methods: {
        onItemClick(item) {
            console.log('항목이 클릭되었습니다:', item);
        }
    }
};
</script>
